import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useModals } from '../../../contexts/ModalContext.jsx'
import { IconSparkle, Svg } from '../../../components/Icons.jsx'
import { HERO_PHOTO, LOGOS } from '../constants/photos.js'
import { INTAKE_PATH } from '../constants/links.js'

const PHRASE = 'your whole health picture'

// ✓ as an icon rather than text — see IconSparkle.
const check = (
  <Svg size="1em" strokeWidth="3" aria-hidden="true" style={{ display: 'inline', verticalAlign: '-0.15em' }}>
    <path d="M5 12l4.5 4.5L19 7" />
  </Svg>
)

const trustPills = [
  '503A pharmacy partners',
  'Licensed in all 50 states',
  'Board-certified providers',
]

export function Hero() {
  const { openBarry } = useModals()
  const [typed, setTyped] = useState('')
  const [done, setDone] = useState(false)

  useEffect(() => {
    let i = 0
    let timer
    const tick = () => {
      i += 1
      setTyped(PHRASE.slice(0, i))
      if (i >= PHRASE.length) {
        setDone(true)
        return
      }
      timer = setTimeout(tick, 70)
    }
    timer = setTimeout(tick, 400)
    return () => clearTimeout(timer)
  }, [])

  return (
    <section id="hero" className="hero-10x">
      <picture>
        <source media={HERO_PHOTO.mobileMedia} srcSet={HERO_PHOTO.mobileSrc} />
        <img className="hero-10x-photo" src={HERO_PHOTO.src} alt="" fetchPriority="high" />
      </picture>
      <div className="hero-10x-veil" />

      <div className="hero-10x-wrap">
        <div className="hero-10x-content">
          <div className="hero-10x-tag">
            <span>
              <IconSparkle /> Provider-Guided · Credible
            </span>
          </div>
          <h1>
            Real medicine for weight, hormones &amp; longevity —{' '}
            <em>prescribed</em> and delivered.
          </h1>
          {/* The untyped rest of the phrase is laid out invisibly so the line
              wraps to its final height up front — on phones the phrase wraps
              to a second line mid-typing, which pushed the CTAs down (CLS). */}
          <div className="hero-10x-typed">
            HealBerry, built around <span className="sr-only">{PHRASE}</span>
            <span aria-hidden="true">
              <span className="typed-word">{typed}</span>
              {!done && <span className="typed-caret">|</span>}
              <span className="typed-rest">{PHRASE.slice(typed.length)}</span>
            </span>
          </div>
          <p className="hero-10x-sub">
            Licensed providers, real labs, and ongoing monitoring — not a vending-machine
            prescription. Weight, hormones, peptides, longevity, labs, and same-day care, all from
            home.
          </p>
          <div className="hero-10x-ctas">
            <Link to={INTAKE_PATH} className="btn btn-berry btn-lg">
              Start my free visit
            </Link>
            <button type="button" onClick={openBarry} className="btn btn-ghost-white btn-lg">
              <IconSparkle /> Find my treatment · 60-sec
            </button>
          </div>
          <div className="hero-10x-risk">
            <span>
              {check} Free — no card required
            </span>
            <span>
              {check} Takes ~60 seconds
            </span>
            <span>
              {check} Private &amp; HIPAA-secure
            </span>
          </div>
          <div className="hero-10x-trust">
            {trustPills.map((pill) => (
              <div key={pill} className="tp">
                <span className="dot" />
                {pill}
              </div>
            ))}
          </div>
        </div>

        <div className="hero-10x-art" aria-hidden="true">
          <div className="hero-logo-wrap">
            {/* Lazy: the art column is display:none below 1000px, and a lazy
                image that isn't rendered is never fetched — keeps 19 KB off
                the mobile critical path. */}
            <img src={LOGOS.vertWhite} alt="" width={440} height={256} loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  )
}
